import React from 'react';
import YouTubeEmbed from '../components/YouTubeEmbed';

const YouTubeTestPage: React.FC = () => {
  // Example YouTube video IDs to test
  const testVideos = [
    { id: 'dQw4w9WgXcQ', title: 'Example Video 1 (Normal ID)' },
    { id: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ', title: 'Example Video 2 (Full URL)' },
    { id: 'https://youtu.be/dQw4w9WgXcQ', title: 'Example Video 3 (Short URL)' },
    { id: 'invalid-id', title: 'Invalid ID Test' },
    { id: '', title: 'Empty ID Test' },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-navy-black to-deep-navy py-8 px-4">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold text-center text-accent-blue mb-10">YouTube Embed Component Test</h1>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {testVideos.map((video, index) => (
            <div 
              key={index} 
              className="bg-deep-navy/50 backdrop-blur-lg rounded-2xl border border-navy-blue p-6"
            >
              <h2 className="text-xl font-semibold text-light mb-4">{video.title}</h2>
              
              <div className="aspect-video">
                <YouTubeEmbed 
                  videoId={video.id} 
                  title={video.title} 
                />
              </div>
              
              <p className="text-medium-gray text-sm mt-2">Video ID: {video.id}</p>
            </div>
          ))}
        </div>
        
        <div className="mt-12 text-center">
          <h2 className="text-2xl font-semibold text-light mb-4">How to Use</h2>
          <div className="bg-dark-navy/50 rounded-xl p-6 max-w-2xl mx-auto text-left">
            <p className="text-medium-gray mb-3">
              The YouTubeEmbed component accepts various formats:
            </p>
            <ul className="list-disc pl-5 text-medium-gray space-y-2">
              <li>Just the video ID: <code className="bg-navy-blue/30 px-2 py-1 rounded">dQw4w9WgXcQ</code></li>
              <li>Full YouTube URL: <code className="bg-navy-blue/30 px-2 py-1 rounded">https://www.youtube.com/watch?v=dQw4w9WgXcQ</code></li>
              <li>Short YouTube URL: <code className="bg-navy-blue/30 px-2 py-1 rounded">https://youtu.be/dQw4w9WgXcQ</code></li>
              <li>Embed URL: <code className="bg-navy-blue/30 px-2 py-1 rounded">https://www.youtube.com/embed/dQw4w9WgXcQ</code></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default YouTubeTestPage;